import { render, staticRenderFns } from "./ServiceSettings.vue?vue&type=template&id=7ab7cecc&"
import script from "./ServiceSettings.vue?vue&type=script&lang=js&"
export * from "./ServiceSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports